import V1EmailPage from '@/pages/v1/signUp/EmailPage'
import V2EmailPage from '@/pages/v2/signUp/EmailPage'
import { useABTestVariant } from '@app-studio-web/ui/contexts/ABTestContext'
import BaselineEmailPage from '@app-studio-web/ui/pages/signUp/EmailPage'

export default function VariantEmailPage() {
  const { variant } = useABTestVariant()

  switch (variant) {
    case 'v1':
      return <V1EmailPage />
    case 'v2':
      return <V2EmailPage />
    default:
      return <BaselineEmailPage />
  }
}
